import React from "react";

import "../../../../styles/css/App.css";
import {Grid} from "@material-ui/core";
import {withRouter} from "react-router-dom";
import Card from "@material-ui/core/Card";
import * as Constants from "../../../../consts/Constants.js";
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import VisibilityOffRoundedIcon from '@mui/icons-material/VisibilityOffRounded';
import VolumeUpRoundedIcon from '@mui/icons-material/VolumeUpRounded';
import VolumeOffRoundedIcon from '@mui/icons-material/VolumeOffRounded';

import AlertItem from "./alert-item"
import EmergencyMap from "./map"

import {Howl} from "howler";
import alerter from "../../../alerts/alerter"
import service from '../../../../plas/services/emergency/service';
import {VictimState, states} from '../../../../plas/services/emergency/models';

const alertSound = new Howl({
    src: ["./emergency-alert-sound.mp3"],
    loop: true,
});

const warnSound = new Howl({
    src: ["./emergency-warning-sound.mp3"],
    loop: true,
});


function Live({history}) {

    const playingAlertSound = React.useRef(false);
    const playingWarnSound = React.useRef(false);

    const [victims, setVictims] = React.useState([]);
    const [showVictims, setShowVictims] = React.useState([]);
    const [victimsMap, setVictimsMap] = React.useState([]);
    const [center, setCenter] = React.useState({lat: Constants.LATITUD_AYACUCHO, lng: Constants.LONGITUD_AYACUCHO});

    const [filters, setFilters] = React.useState({alarm: true, old: false, ok: false});

    let timer = React.useRef(null);

    React.useEffect(() => {
        loadVictims();
        timer.current = setInterval(() => loadVictims(), 10000);
    }, []);

    React.useEffect(() => {
        checkSound(victims);
        checkToShow(victims);
    }, [filters]);

    React.useEffect(() => {
        let newVictimsMap = victims.filter((victim) => {
            return victim.state === states.victimStates.ALERT ||
                victim.state === states.victimStates.DANGER ||
                victim.state === states.victimStates.WARN
        });
        setVictimsMap(newVictimsMap);
        checkToShow(victims);
        checkSound(victims);
    }, [victims]);

    React.useEffect(() => () => {
        clearInterval(timer.current);
        timer.current = null;
    }, []);

    const checkToShow = (victims) => {
        let toShow = victims.filter((item) => item.state !== states.victimStates.OK || filters.ok);
        let toShow2 = toShow.filter((item) => item.state !== states.victimStates.INFO || filters.old);
        setShowVictims(toShow2);
    }

    const checkSound = (victims) => {
        let alertSoundCondition = (victim) => (victim.alert && victim.alert.state === 0);
        let playAlert = victims.some(alertSoundCondition);

        if (playAlert) {
            if (!playingAlertSound.current) {
                alertSound.play();
                warnSound.pause();
                playingAlertSound.current = true;
                playingWarnSound.current = false;
            }
        } else {
            alertSound.pause();
            playingAlertSound.current = false;

            let warnSoundCondition = (victim) => (victim.state === states.victimStates.DANGER);
            let playWarn = victims.some(warnSoundCondition);

            if (playWarn && filters.alarm) {
                if (!playingWarnSound.current) {
                    warnSound.play();
                    playingWarnSound.current = true;
                }
            } else {
                warnSound.pause();
                playingWarnSound.current = false;
            }
        }
    }

    const loadVictims = () => {
        service.api.victims.get((response) => {
            if (response.error != null) {
                alerter.showError(response.error);
            } else {
                let data = response.result.sort(VictimState.compare)
                setVictims(data);
            }
        });

    }

    const onChange = (victim) => {
        if (victim.alert.state === 3) {
            victim.alert = undefined;
            victim.prepare();
            let newVictims = victims.sort(VictimState.compare)
            setVictims([...newVictims]);
        } else {
            setVictims([...victims]);
        }
    }

    const onLocation = (location) => {
        setCenter({lat: location.latitude, lon: location.longitude})
    }

    const ColoredLine = ({color, marginTop, marginBottom}) => (
        <hr
            style={{
                color: color,
                backgroundColor: color,
                marginTop: marginTop !== undefined ? marginTop : 6,
                marginBottom: marginBottom !== undefined ? marginBottom : 16,
                height: 2
            }}
        />
    );

    return (
        <div>
            <Grid container>
                <Grid item xs={false} lg={0}/>
                <Grid item xs={12} lg={12}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Grid container spacing={2}>
                                <Grid item xs={true}>
                                    <p style={{fontSize: '28px', textAlign: 'left'}}>
                                        Mapa en vivo
                                    </p>
                                </Grid>
                            </Grid>
                            <ColoredLine color="gray" marginBottom={0}/>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={true}/>
                                        <Grid item>
                                            <Box
                                                display="flex"
                                                alignItems="center"
                                                height="100%">
                                                <span style={{marginRight: 2}}>Correctas</span>
                                                <IconButton onClick={() => setFilters({...filters, ok: !filters.ok})}>
                                                    {filters.ok ? (
                                                        <VisibilityRoundedIcon fontSize="small"/>
                                                    ) : (
                                                        <VisibilityOffRoundedIcon fontSize="small"/>
                                                    )}
                                                </IconButton>
                                            </Box>
                                        </Grid>
                                        <Grid item>
                                            <Box
                                                display="flex"
                                                alignItems="center"
                                                height="100%">
                                                <span style={{marginRight: 2}}>Sin datos</span>
                                                <IconButton onClick={() => setFilters({...filters, old: !filters.old})}>
                                                    {filters.old ? (
                                                        <VisibilityRoundedIcon fontSize="small"/>
                                                    ) : (
                                                        <VisibilityOffRoundedIcon fontSize="small"/>
                                                    )}
                                                </IconButton>
                                            </Box>
                                        </Grid>
                                        <Grid item>
                                            <Box
                                                display="flex"
                                                alignItems="center"
                                                height="100%">
                                                <span style={{marginRight: 2}}>Perimetral</span>
                                                <IconButton
                                                    onClick={() => setFilters({...filters, alarm: !filters.alarm})}>
                                                    {filters.alarm ? (
                                                        <VolumeUpRoundedIcon fontSize="small"/>
                                                    ) : (
                                                        <VolumeOffRoundedIcon fontSize="small"/>
                                                    )}
                                                </IconButton>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    {showVictims.map((item) => (
                                        <AlertItem center={center} key={item.userId} data={item} onChange={onChange} onLocation={onLocation}/>
                                    ))}
                                </Grid>
                            </Grid>

                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Card>
                                <EmergencyMap center={center} victims={victimsMap}/>
                            </Card>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={false} lg={0}/>
            </Grid>
        </div>
    );

}

export default withRouter(Live);